import { icons } from '@/helpers/icons'

// Filter type constants
export const FILTER_TYPE = {
  COMBOBOX: 'combobox',      // Intermediate level - select to drill down
  CHECKBOX: 'checkbox',      // Leaf level - multi-select with checkboxes
  PRICE: 'price',            // Special price filter
  QUANTITY: 'quantity',      // Special quantity filter
  CUSTOM_FIELD: 'custom_field', // Text input filter for custom fields
  FAST_ACTION: 'fast_action', // Fast action filters (emit only)
  RESTOCKABLE: 'restockable'  // Top-level switch: on = send param, off = don't send
}

export const CATEGORIES_FILTER_ITEM = { icon: { is_local: true, value: icons.icon_multisport }, name: 'Categories', field: 'categories', key_name: 'categories', fetchFn: 'fetchCategoryOptions', filterType: FILTER_TYPE.CHECKBOX }
export const BRAND_FILTER_ITEM = { icon: 'heroicons:tag', name: 'Brand', field: 'brand', key_name: 'brand', fetchFn: 'fetchFieldFilterOptions', useFetchFn: true, filterType: FILTER_TYPE.CHECKBOX }
export const ATTRIBUTE_FILTER_ITEM = { icon: 'heroicons:information-circle', name: 'Attribute', field: 'attributes', key_name: 'attribute', fetchFn: 'fetchAttributeOptions', filterType: FILTER_TYPE.CHECKBOX }
export const GRADED_FILTER_ITEM = { icon: 'heroicons:scale-20-solid', name: 'Graded', field: 'graded', key_name: 'graded', fetchFn: 'fetchGradedOptions', filterType: FILTER_TYPE.CHECKBOX }
export const GRADE_FILTER_ITEM = { icon: 'heroicons:scale-20-solid', name: 'Grader', field: 'grader', key_name: 'grader', fetchFn: 'fetchGraderOptions', filterType: FILTER_TYPE.CHECKBOX }
export const YEAR_FILTER_ITEM = { icon: 'heroicons:calendar', name: 'Year', field: 'year', key_name: 'year', fetchFn: 'fetchFieldFilterOptions', useFetchFn: true, filterType: FILTER_TYPE.CHECKBOX }
export const BOX_FILTER_ITEM = { icon: 'heroicons:archive-box', name: 'Box', field: 'box', key_name: 'box', fetchFn: 'fetchFieldFilterOptions', useFetchFn: true, filterType: FILTER_TYPE.CHECKBOX }
export const ROW_FILTER_ITEM = { icon: 'heroicons:queue-list', name: 'Row', field: 'row', key_name: 'row', fetchFn: 'fetchFieldFilterOptions', useFetchFn: true, filterType: FILTER_TYPE.CHECKBOX }
export const SHELF_FILTER_ITEM = { icon: 'heroicons:rectangle-stack', name: 'Shelf', field: 'shelf', key_name: 'shelf', fetchFn: 'fetchFieldFilterOptions', useFetchFn: true, filterType: FILTER_TYPE.CHECKBOX }
export const CABINET_FILTER_ITEM = { icon: 'heroicons:building-library', name: 'Cabinet', field: 'cabinet', key_name: 'cabinet', fetchFn: 'fetchFieldFilterOptions', useFetchFn: true, filterType: FILTER_TYPE.CHECKBOX }

// Location filter - parent with nested children
export const LOCATION_FILTER_ITEM = { 
  icon: 'heroicons:map-pin', 
  name: 'Location', 
  key_name: 'location', 
  filterType: FILTER_TYPE.COMBOBOX,
  children: [
    BOX_FILTER_ITEM,
    ROW_FILTER_ITEM,
    SHELF_FILTER_ITEM,
    CABINET_FILTER_ITEM,
  ]
}
export const TEAM_FILTER_ITEM = { icon: 'heroicons:information-circle', name: 'Team', field: 'team', key_name: 'team', fetchFn: 'fetchFieldFilterOptions', useFetchFn: true, filterType: FILTER_TYPE.CHECKBOX }
export const SET_FILTER_ITEM = { icon: 'heroicons:information-circle', name: 'Set', field: 'set', key_name: 'set', fetchFn: 'fetchFieldFilterOptions', useFetchFn: true, filterType: FILTER_TYPE.CHECKBOX }
export const STATUS_TYPES_FILTER_ITEM = { icon: { is_local: true, value: icons.status_spinner }, name: 'Status', field: 'status', key_name: 'status', fetchFn: 'fetchStatusTypesOptions', filterType: FILTER_TYPE.CHECKBOX }
export const LISTINGS_FILTER_ITEM = { icon: 'heroicons:shopping-cart', field: 'listing', name: 'Listing', key_name: 'listing', fetchFn: 'fetchListingOptions', filterType: FILTER_TYPE.CHECKBOX }
export const PRICE_FILTER_ITEM = { icon: 'heroicons:currency-dollar', name: 'Price', key_name: 'price', filterType: FILTER_TYPE.PRICE }
export const QUANTITY_FILTER_ITEM = { icon: 'heroicons:hashtag', name: 'Quantity', key_name: 'quantity', filterType: FILTER_TYPE.QUANTITY }
export const MISSING_DETAILS_FILTER_ITEM = { icon: 'heroicons:exclamation-triangle', name: 'Missing Details', key_name: 'missing_details', filterType: FILTER_TYPE.FAST_ACTION, fastActionIndex: 0 }
export const SUGGESTED_EDITS_FILTER_ITEM = { icon: 'heroicons:light-bulb', name: 'Suggested Edits', key_name: 'suggested_edits', filterType: FILTER_TYPE.FAST_ACTION, fastActionIndex: 1 }
export const UNREVIEWED_FILTER_ITEM = { icon: 'heroicons:eye-slash', name: 'Unreviewed', key_name: 'unreviewed', filterType: FILTER_TYPE.FAST_ACTION, isUnreviewed: true }
export const RESTOCKABLE_FILTER_ITEM = { icon: 'heroicons:arrow-path', name: 'Restockable', field: 'restockable', key_name: 'restockable', filterType: FILTER_TYPE.RESTOCKABLE }

// Custom Fields filter - children are dynamically generated from userStore.customFields
export const CUSTOM_FIELDS_FILTER_ITEM = { 
  icon: 'heroicons:adjustments-horizontal', 
  name: 'Custom Fields', 
  key_name: 'custom_fields', 
  filterType: FILTER_TYPE.COMBOBOX,
  isDynamic: true // Flag to indicate children should be fetched dynamically
}


export const FILTERS_BLOCK_1 = [
  STATUS_TYPES_FILTER_ITEM,
  LISTINGS_FILTER_ITEM,
  PRICE_FILTER_ITEM,
  // CATEGORIES_FILTER_ITEM,
  // ATTRIBUTE_FILTER_ITEM,
  // YEAR_FILTER_ITEM,
  // SET_FILTER_ITEM,
  // BRAND_FILTER_ITEM,
  // TEAM_FILTER_ITEM,
  // GRADED_FILTER_ITEM,
  // GRADE_FILTER_ITEM,
  // LOCATION_FILTER_ITEM,
  // QUANTITY_FILTER_ITEM,
  // CUSTOM_FIELDS_FILTER_ITEM,
  // RESTOCKABLE_FILTER_ITEM,
  // { icon: { is_local: true, value: icons.text_T }, name: 'Content' }
]

export const FILTER_CONFIGS = [
  CATEGORIES_FILTER_ITEM,
  BRAND_FILTER_ITEM,
  ATTRIBUTE_FILTER_ITEM,
  TEAM_FILTER_ITEM,
  SET_FILTER_ITEM,
  GRADED_FILTER_ITEM,
  GRADE_FILTER_ITEM,
  YEAR_FILTER_ITEM,
  BOX_FILTER_ITEM,
  ROW_FILTER_ITEM,
  SHELF_FILTER_ITEM,
  CABINET_FILTER_ITEM,
  STATUS_TYPES_FILTER_ITEM,
  LISTINGS_FILTER_ITEM,
  PRICE_FILTER_ITEM,
  QUANTITY_FILTER_ITEM,
]

export const AVAILABLE_FILTERS = {
  attribute: [],
  brand: [],
  category: [],
  team: [],
  set: [],
  graded: [],
  grader: [],
  team: [],
  year: [],
  box: [],
  row: [],
  shelf: [],
  cabinet: [],
}

// Listings filter condition options
export const LISTINGS_FILTER_CONDITION_OPTIONS = [
  { value: 'is', label: 'is', paramKey: 'listedOn' },
  { value: 'is_not', label: 'is not', paramKey: 'notListedOn' }
]

// Listings platform keys mapping (from key_name to URL param value)
export const LISTINGS_FILTER_CONNECTION_MAP = {
  ebayListed: 'ebay',
  collxListed: 'collx',
  whatnotListed: 'whatnot',
  shopifyListed: 'shopify',
  hasNoListings: 'none'
}

// Params that should be extracted from itemFilters and passed as base/query params (not in filter string)
export const BASE_PARAM_KEYS = [
  'sortBy',
  'status',
  'priceMin',
  'priceMax',
  'priceBetween',
  'quantityMin',
  'quantityMax',
  'quantityBetween',
  'q',
  'listedOn',
  'notListedOn',
  'customField',
  'restockable',
]

export const PRICE_FILTER_CONFIG = {
  fieldMin: 'priceMin',
  fieldMax: 'priceMax',
  fieldBetween: 'priceBetween',
  minLabel: 'Price Min',
  maxLabel: 'Price Max',
  betweenLabel: 'Price Between',
  minPlaceholder: '0',
  maxPlaceholder: '0',
  betweenPlaceholder: '0-0',
  step: 0.01,
  rangeLabel: 'Price Range',
  type: 'price',
  icon: 'heroicons:currency-dollar',
}

export const QUANTITY_FILTER_CONFIG = {
  fieldMin: 'quantityMin',
  fieldMax: 'quantityMax',
  fieldBetween: 'quantityBetween',
  minLabel: 'Quantity Min',
  maxLabel: 'Quantity Max',
  betweenLabel: 'Quantity Between',
  minPlaceholder: '0',
  maxPlaceholder: '0',
  betweenPlaceholder: '0-0',
  step: 1,
  rangeLabel: 'Quantity Range',
  type: 'quantity',
  icon: 'heroicons:hashtag',
}
